/*
 * Voyado Recommendations controller (PDP).
 * ----------------------------------------
 * Thin per-surface controller: lifecycle + one VoyadoCarousel.attach call whose
 * opts.fetch runs the productPage query and normalises the response to colour
 * groups. The scroll engine, slide wrapper, cards-rendered dispatch and controls
 * mirror all live in the shared assets/voyado-carousel.js (window.VoyadoCarousel).
 *
 * Product based (productKey + algorithm, PDP only). productKey = product.id
 * (data-product-key) — the Shopify handle returns HTTP 400 on the live cluster.
 * algorithm map: similar→ALTERNATIVES, complementary→STYLE_WITH,
 * more_from_series→MORE_FROM_SERIES.
 *
 * Loaded section-scoped + URL-deduped (type=module) — the global Voyado trio
 * (client/renderer/behaviour) is already deferred in layout/theme.liquid.
 */
;(function () {
  'use strict';

  var SELECTOR = '[data-voyado-recommendations]';
  var attached = new WeakSet();

  function attach(section) {
    if (attached.has(section) || !window.VoyadoCarousel) return;
    attached.add(section);

    var type = section.getAttribute('data-recommendation-type') || 'similar';
    var productKey = section.getAttribute('data-product-key') || '';
    var rawLimit = parseInt(section.getAttribute('data-recommendation-limit'), 10);
    var limit = rawLimit > 0 ? Math.min(24, rawLimit) : 12;
    var algorithm = type === 'complementary'
      ? 'STYLE_WITH'
      : (type === 'more_from_series' ? 'MORE_FROM_SERIES' : 'ALTERNATIVES');

    window.VoyadoCarousel.attach(section, {
      trigger: 'intersection',
      fetch: function () {
        if (!productKey || !window.VoyadoClient || !window.VoyadoClient.productPage) {
          return Promise.reject(new Error('voyado-recommendations: no productKey/client'));
        }
        return window.VoyadoClient.productPage(
          { productKey: productKey, presentCustom: 'swatch_image_url|product_badges|colour_name' },
          { recommendationLists: [{ id: type, algorithm: algorithm, limit: limit }] }
        ).then(function (res) {
          var list = res && res.recommendationLists && res.recommendationLists[0];
          return ((list && list.productGroups) || [])
            .map(function (g) { return (g && g.products) || []; })
            .filter(function (ps) { return ps.length; })
            .slice(0, limit);
        });
      }
    });
  }

  function initAll(root) {
    var r = root || document;
    var nodes = r.querySelectorAll ? r.querySelectorAll(SELECTOR) : [];
    nodes.forEach(attach);
  }

  function teardown(root) {
    if (!root || !root.querySelectorAll || !window.VoyadoCarousel) return;
    root.querySelectorAll(SELECTOR).forEach(function (section) {
      window.VoyadoCarousel.detach(section);
      attached.delete(section);
    });
  }

  if (document.readyState === 'complete') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
})();
